import { getString } from '../../../helpers/string-helpers';

const Author = ({ authors }) => {
  const authorCount = authors.length;
  const avatarImgDefault =
    'https://rippling.imgix.net/images/default-author-thumb.svg';

  if (authorCount === 0) {
    return null;
  }

  if (authorCount === 1) {
    return (
      <div className="column flex flex-col w-100% multiLine-draw-card">
        <div className="wrapper flex justify-start xsx:flex-col">
          <div className="imagex h-80 w-80">
            <img
              className="w-100% h-100% rounded-100"
              loading="lazy"
              src={
                authors[0]?._avatarImgSrc || avatarImgDefault
              }
            />
          </div>

          <div className="wrapper pl:0 max-w-400 xsx:pt-16 sm:pl-24 smx:pt-16 md:max-w-600">
            <h3 className="font-bold font-body text-20">
              {authors[0]?.slug ? (
                <a
                  className="no-underline multiLine-draw font-bold"
                  href={`/blog/author/${authors[0].slug}`}
                >
                  {authors[0].name}
                </a>
              ) :
                <span className="font-bold">{authors[0].name}</span>
              }
            </h3>
            <p
              dangerouslySetInnerHTML={{ __html: authors[0].title }}
              className="mb-16 text-18"
            />
            <p
              dangerouslySetInnerHTML={{ __html: authors[0].description }}
              className="text-16"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="column flex flex-col items-start w-100%">
      {authors.map((author, index) => (
        <div
          key={index}
          className="wrapper flex items-center justify-start mb-24 multiLine-draw-card"
        >
          <div className="imagex h-80 w-80 overflow-hidden relative rounded-50 flex min-w-[80px]">
            <img
              className="w-100%"
              loading="lazy"
              src={author?._avatarImgSrc || avatarImgDefault}
            />
          </div>

          <div className="wrapper max-w-600 pl-24">
            <h3 className="font-body leading-28 text-20">
              {author?.slug ? (
                <a
                  className="no-underline multiLine-draw font-bold"
                  href={`/blog/author/${author.slug}`}
                >
                  {author.name}
                </a>
              ) :
                <span className="font-bold">{author.name}</span>
              }
            </h3>
            <p className="mb-16 text-18">{author.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

const Authors = ({ authors, locale }) => {
  const authorLabel = getString('authorText', locale);

  if (authors) {
    return (
      <div className="Authors wrapper pb-64 md:pt-64 md:pb-112 bg-white">
        <div className="grid max-w-100% mx-auto md:px-20 sm:max-w-725 px-0">
          <div className="row">
            <div className="column flex flex-col items-center w-100%">
              <h3 className="font-bold border-b-1 border-tertiary-gray3 font-body mb-24 pb-20 text-22 w-100%">{`${authorLabel}${
                authors.length > 1 ? 's' : ''
              }`}</h3>
            </div>
          </div>

          <div className="row pt-24">
            <Author authors={authors} />
          </div>
        </div>
      </div>
    );
  } else {
    console.log(`Error in Authors : invalid data.\n\nauthors: ${authors}`);
  }
};

export default Authors;
